module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addressTitle":{"titleMasc":"Herr","titleFem":"Frau"}},"en":{},"it":{},"fr":{}}')
  delete Component.options._Ctor
}
